module.exports = __webpack_public_path__ + "assets/img/vehicles.54d48837.svg";